import { render, staticRenderFns } from "./AcoesRetomar.vue?vue&type=template&id=197dfa2e&scoped=true"
import script from "./AcoesRetomar.vue?vue&type=script&lang=js"
export * from "./AcoesRetomar.vue?vue&type=script&lang=js"
import style0 from "./AcoesRetomar.vue?vue&type=style&index=0&id=197dfa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197dfa2e",
  null
  
)

export default component.exports